<article class="payment" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <div class="process">
      <div>&nbsp;</div>
      <sot-stepper activeStep="payment"></sot-stepper>
      <div>&nbsp;</div>
    </div>

    <h1 langkey="payment_title"></h1><!--Vielen Dank für Ihre Bestellung!-->
  </header>

  <div class="content">
    <div class="box">
      <ng-container *ngIf="pay_at_terminal">
        <h3 langkey="payment_terminal_title"></h3><!--JETZT ZAHLEN-->

        <div class="icon" inlineSVG="sot/sot-icon.svg#sot-pay_at_terminal" [setSVGAttributes]="{class: 'box-icon'}">
        </div>
        <p langkey="payment_terminal_text"></p><!--Bitte folgen Sie den Anweisungen auf dem EC Terminal.-->
      </ng-container>
      <ng-container *ngIf="pay_at_pos">
        <h3 langkey="payment_pos_title"></h3><!--JETZT ZAHLEN-->

        <div class="icon" inlineSVG="sot/sot-icon.svg#sot-pay_at_pos" [setSVGAttributes]="{class: 'box-icon'}"></div>
        <p langkey="payment_pos_text"></p><!--Bitte nehmen Sie Ihren Kassenbon und bezahlen Sie jetzt ab der Kasse.-->
      </ng-container>
      <ng-container *ngIf="voucher_pay">
        <h3 langkey="payment_voucher_pay_title"></h3>
        <div class="icon" inlineSVG="sot/sot-icon.svg#sot-qrscan-ani" [setSVGAttributes]="{class: 'box-icon-voucher'}">
        </div>
        <p langkey="payment_voucher_pay_info"></p>
      </ng-container>
      <ng-container *ngIf="!voucher_pay">
        <div class="downpay" inlineSVG="sot/sot-icon.svg#sot-down_arrows" [setSVGAttributes]="{class: 'arrows'}"></div>
      </ng-container>
    </div>

    <sot-countdown *ngIf="show_countdown" [controls]="true" [countdown_sec]="20"
      (statusChanged)="countdownStatusChanged($event)"></sot-countdown>

    <p *ngIf="show_countdown" langkey="done_home" class="counter_msg highlight"></p>
    <!--Sie werden zur Startseite weitergeleitet. -->
    <a *ngIf="show_countdown" (click)="newOrder()" langkey="button_home" class="btn"></a><!--Neue Bestellung-->
  </div>

  <footer *ngIf="has_payment_image">
    <img [src]="payment_image_path" class="ya_image">
  </footer>
</article>